import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { CursoCartao } from 'Component/Curso';
import Paginacao from 'Component/Paginacao';
import Categoria from 'Interface/Categorias';
import { useRecuperarCategoriasQuery, useRecuperarCursosQuery } from 'Service';

const Visualizar = (): React.ReactElement => {
  const { slug = '' } = useParams();
  const [searchParams] = useSearchParams();

  const {
    data: { categorias: [categoria] } = { categorias: [{} as Categoria] },
  } = useRecuperarCategoriasQuery({
    finder: 'slug',
    options: { slug: { slug: slug } },
  });
  const { data: { cursos, paginacao } = {}, isFetching } =
    useRecuperarCursosQuery(
      {
        finder: 'sortWithPriority',
        page: searchParams.get('pagina') || 1,
        options: { categoria_id: categoria.id },
      },
      { skip: !categoria.id }
    );

  return (
    <div
      className="animate__animated animate__fadeIn"
      style={{ minHeight: window.outerHeight }}
    >
      <div
        className="hf-400 d-flex align-items-end pb-5"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(${categoria.imagem})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          marginTop: '-130px',
        }}
      >
        <div className="container">
          <h1 className="display-2 text-white text-center">{categoria.nome}</h1>
        </div>
      </div>
      <div className="container mb-5">
        <div className="row px-3 px-sm-0">
          {cursos?.map((curso) => (
            <div
              key={`${curso.id}-${curso.modificado}`}
              className="col-md-3 mb-3"
            >
              <CursoCartao dados={curso} />
            </div>
          ))}
        </div>
        <Paginacao dados={paginacao} desabilitado={isFetching} />
      </div>
    </div>
  );
};

export default Visualizar;
